<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-0">
          <b-img
            fluid
            :src="brandLogo"
            alt="Login taobao"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            class="mb-1 font-weight-bold"
            title-tag="h2"
          >
          <b-img
            class="d-block d-sm-none "
            style="width:100%"
            fluid
            :src="brandLogo"
            alt="Login taobao"
          />
            เข้าสู่ระบบ
          </b-card-title>

          <!-- form -->
          <validation-observer
            ref="loginForm"
            #default="{invalid}"
          >
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="loginButton"
            >
              <!-- email -->
              <b-form-group
                label="Username"
                label-for="login-username"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Username"
                  vid="username"
                  rules="required"
                >
                  <b-form-input
                    id="login-username"
                    v-model="user"
                    :state="errors.length > 0 ? false:null"
                    name="login-username"
                    placeholder="Username"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Password</label>
                  <b-link :to="{ name: 'forgot-password'}">
                    <small>ลืมรหัสผ่าน?</small>
                  </b-link>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="pass"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="Password"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="invalid || loadButton == false"
                @click="loginButton()"
              >
                <b-spinner v-if="loadButton == false" small />
                เข้าสู่ระบบ
              </b-button>
            </b-form>
          </validation-observer>

          <!-- facebook button -->
          <!-- <b-button block class="px-0 py-0 my-1">
            <fb-signin-button
              :params="fbSignInParams"
              @success="onSignInSuccess"
              @error="onSignInError"
            >
                Sign in with Facebook
            </fb-signin-button>
          </b-button> -->

          <!-- divider -->
          <div class="divider my-2">
            <h2 class="divider-text ">
              ยังไม่มีบัญชี?
            </h2>
          </div>

          <b-button
            block
            type="submit"
            variant="warning"
            :to="{name: 'pages-register'}"
          >
            สมัครสมาชิกใหม่
          </b-button>

        </b-col>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { taobaoService_dotnet   } from '@/views/global'
import axios from 'axios'
import { token_api, header_token } from '@/views/token'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox,
  BCardText, BCardTitle, BImg, BForm, BButton, BAlert, VBTooltip, BCard, BSpinner
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import { getBrand, getBranchId } from '@/branding'
import { dashboardPermission } from '@/navigation/vertical/dashboard.js'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  props:{
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox,
    BCardText, BCardTitle, BImg, BForm, BButton, BAlert, BCard, BSpinner,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: 'admin',
      userEmail: 'admin@demo.com',
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      brandLogo: getBrand().logo,

      // validation rules
      required,
      email,
      profile: [],
      user: '',
      pass: '',

      fbSignInParams: {
        scope: 'email,public_profile',
        return_scopes: true
      },
      loadButton: true,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  async created() {
    this.autoLogin()
    this.detailLogin()
    window.fbAsyncInit = function() {
      this.FB.init({
        appId      : '1480694965278815',
        cookie     : true,  // enable cookies to allow the server to access the session
        xfbml      : true,  // parse social plugins on this page
        version    : 'v11.0' // use graph api version 2.8
      });
    };
    (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = "//connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  },

  methods: {
    login() {
      this.$refs.loginForm.validate().then(success => {
        if (success) {
          useJwt.login({
            email: this.userEmail,
            password: this.password,
          })
            .then(response => {
              localStorage.setItem('cusId', JSON.stringify(1))
              const { userData } = response.data
              useJwt.setToken(response.data.accessToken)
              useJwt.setRefreshToken(response.data.refreshToken)
              localStorage.setItem('userData', JSON.stringify(userData))
              this.$ability.update(userData.ability)

              // ? This is just for demo purpose as well.
              // ? Because we are showing eCommerce app's cart items count in navbar
              this.$store.commit('app-ecommerce/UPDATE_CART_ITEMS_COUNT', userData.extras.eCommerceCartItemsCount)

              // ? This is just for demo purpose. Don't think CASL is role based in this case, we used role in if condition just for ease
              this.$router.replace(getHomeRouteForLoggedInUser(userData.role))
              .then(() => {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: `Welcome ${userData.fullName || userData.username}`,
                    icon: 'CoffeeIcon',
                    variant: 'success',
                    text: `You have successfully logged in as ${userData.role}. Now you can start to explore!`,
                  },
                })
              })
            })
            .catch(error => {
              this.$refs.loginForm.setErrors(error.response.data.error)
            })
        }
      })
    },

    async loginButton(){
      this.loadButton = await false
      var res = []
      var sToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiaWF0IjoxNjQ1NDMxOTM3LCJleHAiOjE2NDU0MzI1Mzd9.GAO0TlWsHDaP_KImlaG6MomhnomjHj5xTWMkrfoNUmw"
      var rToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiaWF0IjoxNjQ1NDMxOTM3LCJleHAiOjE2NDU0MzI1Mzd9.FoUDDNh6hBlWHtHKsagslOFU20v9aYVAhDX9SqKAajE"
      // var abi = [{action: "read", subject: "dashboard"}]
      this.profile = []
      let response = await axios.post(
        taobaoService_dotnet + 'Jinmatai/login',
        // 'https://localhost:5001/Jinmatai/login',
        {
          'username': this.user,
          'password': this.pass,
          'branchId': getBranchId()
        },
        { headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer '+ token_api }}
      )
      res = response.data
      this.$refs.loginForm.validate().then( async success => {
        if( response.data.message == 'success' ) {
          if (success) {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const product = await urlParams.get('product')
            if (product) {
              localStorage.setItem('product_link', JSON.stringify(product))
            }
            await this.profile.push({
              'data': response.data,
              'role': 'user',
              'ability': [
                {action: "manage", subject: "normal"},
                {action: "manage", subject: "Auth"},
                {action: "manage", subject: res.customerInfo.isSeeBankAccount == true ? "high1" : "normal" },
                {action: "manage", subject: res.customerInfo.isBlockWithdraw == false ? "high2" : "normal" },
                ]
            })
            useJwt.setToken(sToken)
            useJwt.setRefreshToken(rToken)
            localStorage.setItem('userData', JSON.stringify(this.profile[0]))
            localStorage.setItem('cusId', JSON.stringify(this.profile[0].data.customerInfo.customerID))
            localStorage.setItem('show_announce', true)
            localStorage.setItem('auth_token', response.data.token)
            this.$ability.update(this.profile[0].ability)

            this.$store.commit('app-ecommerce/UPDATE_CART_ITEMS_COUNT', this.profile[0].data.customerInfo.quantityCart)

            this.$router.replace(getHomeRouteForLoggedInUser(this.profile[0].role))

            // this.$router.replace(dashboardPermission(this.profile.customerInfo.customerId))

            this.loadButton = true

          }
        } else {
          this.$swal({
            position: 'top',
            title: 'ล็อคอินไม่สำเร็จ !',
            text: response.data.message + ' !',
            icon: 'warning',
            customClass: {
              confirmButton: 'btn btn-primary',
              text: 'text-danger'
            },
            buttonsStyling: false,
          })
          this.loadButton = true
        }
      })
    },

    async onSignInSuccess (res) {
      var resProfile = []
      var sToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiaWF0IjoxNjQ1NDMxOTM3LCJleHAiOjE2NDU0MzI1Mzd9.GAO0TlWsHDaP_KImlaG6MomhnomjHj5xTWMkrfoNUmw"
      var rToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiaWF0IjoxNjQ1NDMxOTM3LCJleHAiOjE2NDU0MzI1Mzd9.FoUDDNh6hBlWHtHKsagslOFU20v9aYVAhDX9SqKAajE"
      this.profile = []
      window.FB.api('/me', 'GET', { fields: 'id,name,email,picture' },
      async userInformation => {
        if(userInformation.id){
          if ( userInformation.id ) {
            let response = await axios.post(taobaoService_dotnet + 'app/Customer/facebook-login',
              {
                'userID': userInformation.id,
              },
              { headers: header_token }
            )
            resProfile = response.data
            if ( resProfile.message == 'success' && resProfile.redirectType == 1 ) {
              localStorage.setItem('resFacebook', JSON.stringify(userInformation))
              this.$router.push({path: '/pages/login-facebook'});
            } else if ( resProfile.message == 'success' && resProfile.redirectType == 2 ) {
              await this.profile.push({
                'data': resProfile,
                'role': 'facebook',
                'ability': [
                  {action: "manage", subject: "normal"},
                  {action: "manage", subject: "Auth"},
                  {action: "manage", subject: resProfile.customerInfo.isSeeBankAccount == true ? "high1" : "normal" },
                  {action: "manage", subject: resProfile.customerInfo.isBlockWithdraw == false ? "high2" : "normal" },
                ]
              })
              useJwt.setToken(sToken)
              useJwt.setRefreshToken(rToken)
              localStorage.setItem('userData', JSON.stringify(this.profile[0]))
              localStorage.setItem('cusId', JSON.stringify(this.profile[0].data.customerInfo.customerID))
              localStorage.setItem('show_announce', true)
              localStorage.setItem('auth_token', resProfile.token)
              this.$ability.update(this.profile[0].ability)

              this.$store.commit('app-ecommerce/UPDATE_CART_ITEMS_COUNT', this.profile[0].data.customerInfo.quantityCart)

              this.$router.replace(getHomeRouteForLoggedInUser(this.profile[0].role))

            }
          } else {
            console.log("User cancelled login or did not fully authorize.")
          }
        }
      })
    },
    onSignInError (error) {
      console.log('OH NOES', error)
    },

    async autoLogin() {
      await localStorage.removeItem("toPath");
      if ( this.$route.params.loginCode ) {
        var res = []
        var sToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiaWF0IjoxNjQ1NDMxOTM3LCJleHAiOjE2NDU0MzI1Mzd9.GAO0TlWsHDaP_KImlaG6MomhnomjHj5xTWMkrfoNUmw"
        var rToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiaWF0IjoxNjQ1NDMxOTM3LCJleHAiOjE2NDU0MzI1Mzd9.FoUDDNh6hBlWHtHKsagslOFU20v9aYVAhDX9SqKAajE"
        this.profile = []
        let response = await axios.get(taobaoService_dotnet  + 'app/Customer/login-by-code?LoginCode=' + this.$route.params.loginCode,
        { headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer '+ token_api }})
        res = response.data
        if( res.message == "success" ) {
          await this.profile.push({
            'data': response.data,
            'role': 'auto',
            'ability': [
              {action: "manage", subject: "normal"},
              {action: "manage", subject: "Auth"},
              {action: "manage", subject: res.customerInfo.isSeeBankAccount == true ? "high1" : "normal" },
              {action: "manage", subject: res.customerInfo.isBlockWithdraw == false ? "high2" : "normal" },
              ]
          })
          localStorage.setItem('toPath', JSON.stringify(this.$route.params.loginToPath))
          useJwt.setToken(sToken)
          useJwt.setRefreshToken(rToken)
          localStorage.setItem('userData', JSON.stringify(this.profile[0]))
          localStorage.setItem('cusId', JSON.stringify(this.profile[0].data.customerInfo.customerID))
          localStorage.setItem('show_announce', true)
          localStorage.setItem('auth_token', res.token)
          this.$ability.update(this.profile[0].ability)

          this.$store.commit('app-ecommerce/UPDATE_CART_ITEMS_COUNT', this.profile[0].data.customerInfo.quantityCart)

          this.$router.replace(getHomeRouteForLoggedInUser(this.profile[0].role))
        }
      } else if ( this.$route.params.loginToPath != undefined ) {
        localStorage.setItem('toPath', JSON.stringify(this.$route.params.loginToPath))
      }
    },

    async detailLogin () {
      if ( this.$route.params.token ) {
        localStorage.setItem('tokenAuto', JSON.stringify(this.$route.params.token))
        localStorage.setItem('orderidAuto', JSON.stringify(this.$route.params.orderid))
        var res = []
        var sToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiaWF0IjoxNjQ1NDMxOTM3LCJleHAiOjE2NDU0MzI1Mzd9.GAO0TlWsHDaP_KImlaG6MomhnomjHj5xTWMkrfoNUmw"
        var rToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiaWF0IjoxNjQ1NDMxOTM3LCJleHAiOjE2NDU0MzI1Mzd9.FoUDDNh6hBlWHtHKsagslOFU20v9aYVAhDX9SqKAajE"
        this.profile = []
        let response = await axios.get(taobaoService_dotnet  + 'app/Customer/login-by-code?LoginCode=' + this.$route.params.token,
        { headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer '+ token_api }})
        res = response.data
        if( res.message == "success" ) {
          await this.profile.push({
            'data': response.data,
            'role': 'detail',
            'ability': [
              {action: "manage", subject: "normal"},
              {action: "manage", subject: "Auth"},
              {action: "manage", subject: res.customerInfo.isSeeBankAccount == true ? "high1" : "normal" },
              {action: "manage", subject: res.customerInfo.isBlockWithdraw == false ? "high2" : "normal" },
              ]
          })
          useJwt.setToken(sToken)
          useJwt.setRefreshToken(rToken)
          localStorage.setItem('userData', JSON.stringify(this.profile[0]))
          localStorage.setItem('cusId', JSON.stringify(this.profile[0].data.customerInfo.customerID))
          localStorage.setItem('show_announce', true)
          localStorage.setItem('auth_token', res.token)
          this.$ability.update(this.profile[0].ability)

          this.$store.commit('app-ecommerce/UPDATE_CART_ITEMS_COUNT', this.profile[0].data.customerInfo.quantityCart)

          this.$router.replace(getHomeRouteForLoggedInUser(this.profile[0].role))
        }
      }
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
<style>

.fb-signin-button {
  /* This is where you control how the button looks. Be creative! */
  display: inline-block;
  padding: 13px;
  width: 100%;
  border-radius: 3px;
  background-color: #4267b2;
  color: #fff;
}

</style>
